/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import user from 'js/lib/user';

import { Grid, PageGridContainer } from '@coursera/cds-core';

import useHasThirdPartyOrgEnforcedSSOLogin from 'bundles/saml-sso/shared/hooks/useHasThirdPartyOrgEnforcedSSOLogin';
import { useThirdPartyOrganization } from 'bundles/unified-common/contexts/ThirdPartyOrganizationContext';
import ProgramJoinNotification from 'bundles/unified-home-common/components/enterprise/ProgramJoinNotification';
import RecoveryEmailNotification from 'bundles/unified-home-common/components/enterprise/RecoveryEmailNotification';

const styles = {
  notification: css`
    margin-top: var(--cds-spacing-200);
    background-color: var(--cds-color-white-0);

    & .program-sso-notification:not(:first-child) {
      margin-top: var(--cds-spacing-200);
    }

    & .program-sso-notification:last-child {
      margin-bottom: var(--cds-spacing-200);
    }
  `,
};

const ProgramForceSSONotifications: React.FC = () => {
  const thirdPartyOrg = useThirdPartyOrganization();
  const { isSsoLoginForced } = useHasThirdPartyOrgEnforcedSSOLogin(
    thirdPartyOrg?.id || '',
    user.get().email_address || ''
  );

  if (!isSsoLoginForced) {
    return null;
  }

  return (
    <PageGridContainer css={styles.notification}>
      <Grid item xs={12}>
        <RecoveryEmailNotification />
        <ProgramJoinNotification />
      </Grid>
    </PageGridContainer>
  );
};

export default ProgramForceSSONotifications;
